module.exports = __webpack_public_path__ + "static/l2-service-img3-b65917bedfde47ffae403b2f757df0e6.jpg";